<app-grid
    [columns]="columns"
    [rows]="data.tableRows"
    [tableParams]="data.tableParams"
    [multiSelect]="false"
    [gridName]="gridName"
    (refreshDataFromServer)="refreshData()"
   (rowSelected)="onRowClick($event)"
></app-grid>


